/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Form, Input, notification } from "antd";
import AirbusLogo from "../../assets/images/PNG/airbusLogoBlue.png";
import Styles from "./common.module.scss";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import CONSTANTS from "../../constants/constants";
import { useMutation } from "@tanstack/react-query";
import { login } from "./mutations";
import Cookies from "universal-cookie";

const { OP_LANDING, SUPERVISOR_LANDING } = CONSTANTS.PAGE_ROUTES;
const { NO_ACCESS } = CONSTANTS.ERROR_PAGE;
const { OPERATOR, SUPERVISOR } = CONSTANTS.USER_ROlES;

const Login = () => {
  // global
  const navigate = useNavigate();
  const cookies = new Cookies();

  // set the landing page according to role
  const setLandingPage = (role: string) => {
    switch (role) {
      case OPERATOR:
        navigate(OP_LANDING);
        break;

      case SUPERVISOR:
        localStorage?.setItem("dashboardTab", "Location");
        localStorage?.setItem("flowFilter", "");

        navigate(SUPERVISOR_LANDING);
        break;

      default:
        navigate(NO_ACCESS);
        break;
    }
  };

  // mutation to login

  const loginMutate = useMutation({
    mutationFn: (values: any) => login(values),
    onSuccess: (data) => {
      cookies?.set("token", `${data?.token_type} ${data?.access_token}`);
      const jwtToken: any = jwtDecode(data?.access_token);
      cookies?.set("currentRole", jwtToken?.role_name);
      cookies?.set("userName", jwtToken?.user_name);
      cookies?.set("userId", jwtToken?.user_id);
      cookies?.set("userEmail", jwtToken?.user_name);
      setLandingPage(jwtToken?.role_name);
    },
    onError: (error: any) => {
      console.log(error);

      notification?.error({
        message: error?.response?.data?.detail || "Login Failed",
      });
    },
  });

  return (
    <div className={Styles.loginContainer}>
      <Card className={Styles.loginCard}>
        <img src={AirbusLogo} alt="airbusLogo" height={50} />
        <h4>Welcome to ALOS</h4>
        <Form
          layout="vertical"
          onFinish={(values) => {
            loginMutate?.mutate({
              grant_type: "",
              username: values?.username,
              password: values?.password,
              scope: "",
              client_id: "",
              client_secret: "",
            });
          }}
          className={Styles.loginForm}
        >
          <Form.Item
            label="Email"
            name="username"
            rules={[
              { required: true, message: "Please enter your email ID" },
              { type: "email", message: "Please enter a valid email ID" },
            ]}
          >
            <Input type="email" size="large" allowClear />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <Input.Password size="large" allowClear />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className={Styles.loginButton}
            loading={loginMutate.isPending}
          >
            Login
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
